"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.string.starts-with");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vgMDialog = _interopRequireDefault(require("./vgMDialog"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _vgmImportDialog = _interopRequireDefault(require("./vgmImportDialog2"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    vgMDialog: _vgMDialog.default,
    vgmImportDialog: _vgmImportDialog.default
  },
  props: {
    form: {
      type: Object
    },
    rules: {
      type: Object
    },
    containerTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cargoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    directionList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    containerStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bkContainerDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleFlag: {
      type: String,
      default: ''
    },
    bookingId: {
      type: String,
      default: ''
    },
    preLockFlag: {
      type: Boolean,
      default: null
    },
    topBlInfo: {
      type: Object
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      vgMDialogDialogVisible: false,
      lineTypeList: [{
        value: '0',
        labelEh: 'Feeder',
        labelZh: '支线'
      }, {
        value: '1',
        labelEh: 'Ocean',
        labelZh: '干线'
      }],
      containerManagerList: [],
      vgmImportDialogVisible: false,
      vgMDialogForm: null
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])), {}, {
    disabled: function disabled() {
      if (this.form.pol.startsWith('TH') || this.form.pol.startsWith('TW')) {
        return false;
      }
      return this.form.webBkContainerComs.length <= 1;
    },
    quantityCount: function quantityCount() {
      return this.form.webBkContainerComs.reduce(function (sum, item) {
        return sum + Number(item.quantity);
      }, 0);
    },
    weightCount: function weightCount() {
      var weight = this.form.webBkContainerComs.reduce(function (sum, item) {
        return sum + Number(item.weight);
      }, 0);
      return weight.toFixed(3);
    },
    cntrSizeCount: function cntrSizeCount() {
      var cntrSize = this.form.webBkContainerComs.reduce(function (sum, item) {
        return sum + Number(item.cntrSize);
      }, 0);
      return cntrSize.toFixed(3);
    },
    /**
     * @return {boolean}
     */
    CNXMNDisabled: function CNXMNDisabled() {
      return this.form.pol === 'CNXMN' && this.form.preLock === 1;
    }
  }),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['DOC_CONTAINER_MANAGER'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.containerManagerList = res.DOC_CONTAINER_MANAGER ? res.DOC_CONTAINER_MANAGER : [];
    });
  },
  watch: {
    'form.socCheckFlag': {
      handler: function handler(val) {
        if (val) {
          this.$set(this.rules, 'socReturn', [{
            required: true,
            message: this.$t('home.placehold'),
            trigger: 'change'
          }]);
        } else {
          this.rules.socReturn = [];
          this.$refs.form.clearValidate(['socReturn']);
        }
      },
      immediate: true
    }
    // 取消和货物信息的件重尺联动
    // 'form.webBkContainerComs': {
    //   handler: function (val) {
    //     console.log(val, 2222);
    //     this.handleSum()
    //   },
    //   deep: true
    // }
  },
  mounted: function mounted() {
    // setTimeout(()=>{
    //     console.log(this.form.changeSocCheckFlag,'form.changeSocCheckFlag')
    //     this.form.webBkContainerComs.forEach(item=>{
    //         if(this.form.changeSocCheckFlag){
    //             item.containerManager = 'SOC'
    //         }else{
    //             item.containerManager = 'SIT'
    //         }

    //     })
    // },2000)
    this.vgMDialogForm = this.$refs.vgMDialog.form;
    //延迟加箱信息的逻辑放在父页面，更方便判断是否修改数据提醒保存
    // setTimeout(() => {
    //   if (this.form.webBkContainerComs?.length === 0) {
    //     this.handleAddBox()
    //   }
    // }, 1000)
  },
  methods: {
    tableClass: function tableClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    isDifferent: function isDifferent(fileName) {
      var containerDiff = this.bkContainerDiff;
      // let bkPreContainerDiff  = ["containerNo1","containerType0","sealNo10","quantity0"
      //   ,"overWeight0","cntrSize0","cargoTypeCode0","overLeft0","overRight0","overHeight0"
      //   ,"overForeward0","overAftward0","socReture0"]
      return containerDiff.includes(fileName);
    },
    getVgmContainers: function getVgmContainers() {
      var params = this.$refs.vgMDialog.form;
      var data = [].concat((0, _toConsumableArray2.default)(params.formVgm), (0, _toConsumableArray2.default)(params.deleteVgmList));
      return data;
    },
    handleRemove: function handleRemove(row, index) {
      if (row.bkContainerWebComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkContainerComs.push(row);
      }
      this.form.webBkContainerComs.splice(index, 1);
    },
    handleAddVgmTitle: function handleAddVgmTitle() {
      this.vgMDialogDialogVisible = true;
    },
    handleAddBox: function handleAddBox() {
      var _this$form$webBkPreCo, _this$form;
      var hasCargoTypeEmpty = (_this$form$webBkPreCo = this.form.webBkPreContainerComs) === null || _this$form$webBkPreCo === void 0 ? void 0 : _this$form$webBkPreCo.some(function (item) {
        return item.cargoTypeCode === '0014';
      });
      var data = {
        containerNo: '',
        containerType: '',
        sealNo1: '',
        quantity: 0,
        weight: 0,
        cntrSize: 0,
        cargoTypeCode: '',
        containerStatus: hasCargoTypeEmpty ? 4 : 8,
        overLeft: null,
        overRight: null,
        overHeight: null,
        overForeward: null,
        overAftward: null,
        socReturn: '',
        containerManager: this.form.socCheckFlag === 1 ? 'SOC' : 'SIT'
      };
      if (((_this$form = this.form) === null || _this$form === void 0 ? void 0 : _this$form.webBkContainerComs.length) === 0) {
        data.quantity = this.form.cargoQuantity;
        data.weight = this.form.cargoGrossWeight;
        data.cntrSize = this.form.cargoSize;
      }
      this.form.webBkContainerComs.push(data);
    },
    // 均分
    handleAvg: function handleAvg() {
      var _this2 = this;
      var length = this.form.webBkContainerComs.length;
      var quantityAvg = this.form.cargoQuantity / length;
      this.form.webBkContainerComs.forEach(function (item, index) {
        if (!Math.floor(quantityAvg) && index < _this2.form.cargoQuantity) {
          item.quantity = 1;
        } else {
          item.quantity = Math.floor(quantityAvg);
        }
        item.weight = (_this2.form.cargoGrossWeight / length).toFixed(3);
        item.cntrSize = (_this2.form.cargoSize / length).toFixed(3);
      });
    },
    // 统计
    handleSum: function handleSum() {
      this.form.cargoQuantity = this.quantityCount;
      this.form.cargoGrossWeight = this.weightCount;
      this.form.cargoSize = this.cntrSizeCount;
    },
    // 根据箱号带出
    getContainerType: function getContainerType(containerNo, index) {
      var _this3 = this;
      // 带出下货纸箱信息中的货类
      if (containerNo && !this.form.webBkContainerComs[index].cargoTypeCode && this.form.webBkPreContainerComs[0].cargoTypeCode) {
        this.form.webBkContainerComs[index].cargoTypeCode = this.form.webBkPreContainerComs[0].cargoTypeCode;
      }
      // 自动带出箱型
      if (containerNo) {
        (0, _booking.getContainerTypeByNo)(containerNo).then(function (res) {
          if (res.data) {
            _this3.form.webBkContainerComs[index].containerType = res.data.containerType;
          }
        });
      }
    },
    handleImportVgm: function handleImportVgm() {
      this.vgmImportDialogVisible = true;
    }
  }
};